
    <fieldmagic-dialog
      label="Report Details"
      icon="file-alt"
      [instance]="this"
    >
      <ng-template fieldmagicDialogButtonsTmp>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <table class="table table-bordered">
          <thead>
            <tr>
              <td
                width="30%"
              >
                <fieldmagic-text
                  content="Reported By"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>

              <td
                width="30%"
              >
                <fieldmagic-text
                  content="Job Number"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>

              <td
                width="30%"
              >
                <fieldmagic-text
                  content="Date Reported"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>

              <td
                width="10%"
              >
                <fieldmagic-text
                  content="Photo"
                  purpose="table-header"
                  alignment="center"
                >
                </fieldmagic-text>
              </td>

            </tr>
          </thead>

          <tbody *ngIf="fault$ | async as fault">
            <td>
              {{ fault.reported_by_text }}
            </td>

            <td>
              <a
                *ngIf="fault.job_id | filled"
                [routerLink]="['jobs', fault.job_id]"
                target="_blank"
              >
                {{ '#%s' | sprintf: [fault.job_text] }}
              </a>

              <span *ngIf="fault.job_id | blank">--</span>
            </td>

            <td>
              {{ fault.date_reported | format: 'll' }}
            </td>

            <td class="text-center">
              <a
                *ngIf="fault.image_url | filled"
                href="{{ fault.image_url }}"
                target="_blank"
              >
                {{ 'View Photo' | translate }}
              </a>

              <span *ngIf="fault.image_url | blank">--</span>
            </td>
          </tbody>
        </table>
      </ng-template>
    </fieldmagic-dialog>
  